var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2997 13.2994L10.2618 10.2615M11.8998 6.29971C11.8998 9.39236 9.39268 11.8994 6.30003 11.8994C3.20739 11.8994 0.700308 9.39236 0.700308 6.29971C0.700308 3.20707 3.20739 0.699987 6.30003 0.699987C9.39268 0.699987 11.8998 3.20707 11.8998 6.29971Z",
    stroke: "currentColor",
    strokeWidth: 1.39993,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.22ab609a.svg";
export { ForwardRef as ReactComponent };